import store from "@/store/index";
import { CurrentUser } from "@/models/auth/current.user";

export enum PermissionModes {
  View,
  Edit,
  Delete
}

export default class PermissionsHandler {
  get currentUser(): CurrentUser | null {
    return store.state.identity;
  }

  backoffice: string = "Backoffice";

  Check(
    interfac: string,
    module: string,
    isConfiguration: boolean,
    viewMode: PermissionModes
  ): boolean {
    // Current user does not have role for the interface

    //     if (current?.Roles == null || !current.Roles.Any())
    //     return (false, null);
    // var appPermission = current.Roles.FirstOrDefault(s => s.Interface == @interface);
    // if (appPermission == null)
    //     return (false, null);
    // var rolePermission = appPermission.Permissions.FirstOrDefault(s => s.Module == module);
    // if (rolePermission == null)
    //     return (false, null);
    // if (isConfiguration)
    //     return (rolePermission.CanManageConfigurations, rolePermission);
    // switch (action)
    // {
    //     case ActionModes.Custom:
    //         return (true, rolePermission);
    //     case ActionModes.Query:
    //         return (rolePermission.ViewMode != PermissionTypes.None, rolePermission);
    //     case ActionModes.Create:
    //     case ActionModes.Edit:
    //         return (rolePermission.EditMode != PermissionTypes.None, rolePermission);
    //     case ActionModes.Remove:
    //         return (rolePermission.DeleteMode != PermissionTypes.None, rolePermission);
    //     default:
    //         return (false, rolePermission);

    if (this.currentUser == null) return false;

    const role = !this.currentUser.roles.find(s => s.interface == interfac);
    if (role == null) return false;

    // TODO: check permissions based on current user and their roles
    return true;
  }
}
